import React, { createContext, useContext, ReactNode } from 'react';

import useCioBrowseAndGqlProducts from '~/gridv1_1/hooks/useCioBrowseAndGqlProducts';

import { CIOBrowseProductGridResponse } from '../types/gridResponses';

type CIOBrowseContextType = CIOBrowseProductGridResponse | undefined;

const CIOBrowseContext = createContext<CIOBrowseContextType>(undefined);
interface CIOBrowseProviderProps {
  children: ReactNode;
}

export const CIOBrowseProvider = ({ children }: CIOBrowseProviderProps) => {
  const cioData = useCioBrowseAndGqlProducts();

  return (
    <CIOBrowseContext.Provider value={cioData}>
      {children}
    </CIOBrowseContext.Provider>
  );
};

export const useCioBrowseContext = (): CIOBrowseContextType => {
  return useContext(CIOBrowseContext);
};
